import amplitude from 'amplitude-js';

// Declare window.dataLayer for TypeScript
declare global {
    interface Window {
        dataLayer: any[];
    }
}

const sendAnalyticsEvent = ({ eventName, data }: { eventName: string; data: Record<string, any> }) => {
    try {
        // Send to Amplitude
        amplitude.getInstance().logEvent(eventName, data);
    } catch {
        // err
    }

    try {
        // Send to Google Tag Manager
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                ...data,
            });
        }
    } catch {
        // err
    }
};

export default sendAnalyticsEvent;
